import { getWidth } from "../common";

const columns = 10;
export default Array.from({ length: columns }, (_, current) => {
  const field = `switch_automotive_${current + 1}`;
  return {
    field,
    label: field,
    width: getWidth(columns),
    isSortable: false,
    isCSV: true,
  };
});
